import React from 'react';
import { observer } from 'mobx-react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { withNamespaces, Trans } from 'react-i18next';

import { Link } from 'core/routing';

import { Div } from 'legacyComponents/styled/lib';
import { Avatar } from 'apps/components/shared';
import { media } from 'legacyComponents/styled/styleUtils';
import {
  FullWidthTitle,
  FullWidthDescription as Description,
  TextWrapper,
} from 'legacyComponents/cards/styles';
import { CardIndicator } from 'legacyComponents/cards/types/indicator';
import { Date } from 'apps/components/date';

import { ContentPreview } from 'apps/home/activityFeed/views/contentPreview';

import { imageSrc } from 'apps/file/utils';
import { conf as mainConf } from 'apps/config.yaml';

export const ActivityCard = withNamespaces()(
  observer(({ cardObject }) => {
    if (cardObject === null) {
      return <CardIndicator noMargin={true} type='activity' />;
    }
    const { subject, predicate, object, hasContentPreview, date } = cardObject;
    const subjectName = subject.name;
    const objectName = object ? object.name : '';

    return (
      <Main>
        <Div position='relative' display='block'>
          <Link name={subject.routeName} params={subject.routeParams}>
            <Avatar
              src={imageSrc(
                subject.avatar,
                cardObject.origin.imageFallbackPath,
                mainConf.imgSizes.profile.small,
              )}
            />
          </Link>
        </Div>
        <SentenceWrapper>
          <Title noUnderline>
            {object ? (
              <Trans>
                <Link name={subject.routeName} params={subject.routeParams}>
                  {{ subjectName }}
                </Link>{' '}
                {predicate}{' '}
                <Link name={object.routeName} params={object.routeParams}>
                  {{ objectName }}
                </Link>
              </Trans>
            ) : (
              <Trans>
                <Link name={subject.routeName} params={subject.routeParams}>
                  {{ subjectName }}
                </Link>{' '}
                {predicate}
              </Trans>
            )}
          </Title>
          <Description>
            <Date value={date} />
          </Description>
          {hasContentPreview ? <ContentPreview activity={cardObject} /> : ''}
        </SentenceWrapper>
      </Main>
    );
  }),
);

const Main = styled.div`
  width: calc(100% - 2px);
  border: 1px solid ${props => props.theme.color.wfGrey300};
  padding: 20px;
  margin-bottom: 14px;
  &:hover {
    > div:nth-child(1) > div:nth-child(1) {
      background-color: ${props => props.theme.color.primary};
    }
  }
`;

const SentenceWrapper = styled(TextWrapper)`
  margin-left: 48px;
  ${media.s`
    margin-left: 0px;
  `};
`;

const Title = styled(FullWidthTitle)`
  &:hover {
    text-decoration: none;
  }
  > a {
    color: ${props => props.theme.color.primary};
  }
`;

ActivityCard.propTypes = {
  activity: PropTypes.object,
};
